// import { useState } from "react";
// import { ButtonContainer, Content } from "./component/Header/ToggleButton";
import { Route, Routes } from 'react-router-dom';
import Sidebar from "./component/Header/SideBar";
import { useState } from "react";
import Home from "./component/Home/Home";
// import Calender1 from "./component/calender/Calender1";
import UpdatePass from './component/Login/UpdatePass.jsx'
import AdminHeader from "./component/Header/AdminHeader.jsx"
import AdminRegister from './component/Register/AdminRegister.jsx'
import AdminLogin from './component/Login/AdminLogin.jsx';
import AdminDashboard from './component/Home/AdminHome.jsx'
import ForgotPassword from './component/Login/ForgotPassword.jsx'
import OtpPage from './component/Login/Otp.jsx';
import UserRegister from './component/Register/UserRegister.jsx';
import UserHeader from './component/userHeader/UserHeader.jsx'
import UserLogin from './component/Login/UserLogin.jsx'
import "bootstrap/dist/css/bootstrap.min.css";
import UserHome from './component/userHome/UserHome.jsx';



function App() {
  // const [activeButton, setActiveButton] = useState('button1');
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth1, setSelectedMonth1] = useState(new Date().getMonth());
  const [selectedYear1, setSelectedYear1] = useState(new Date().getFullYear());

  return (
    <>


      {/* <ButtonContainer activeButton={activeButton} setActiveButton={setActiveButton} />
      <Content activeButton={activeButton} /> */}
      <Routes>
        <Route path="/" element={<Sidebar
          setSelectedMonth={setSelectedMonth}
          setSelectedYear={setSelectedYear}
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
          selectedMonth1={selectedMonth1}
          setSelectedMonth1={setSelectedMonth1}
          selectedYear1={selectedYear1}
          setSelectedYear1={setSelectedYear1}
        />}>
          <Route path="/calendar" />
          <Route path="/home" element={<Home/>}/>


        </Route>
        <Route path="/admin" element={<AdminHeader/>}>
          <Route path='register' element={<AdminRegister/>} />
          <Route path='adminLogin' element={<AdminLogin/>} />
          <Route path='adminDashboard' element={<AdminDashboard/>} />
          <Route path='forgotPassword' element={<ForgotPassword/>} />
          <Route path='otppage' element={<OtpPage/>} />
          <Route path='updatePass' element={<UpdatePass/>} />
        </Route>
        <Route path='/user' element={<UserHeader/>}>
          <Route path='userRegister' element={<UserRegister/>} />
          <Route path='userLogin' element={<UserLogin/>} />
          <Route path='userHome' element={<UserHome/>} />


        </Route>
      </Routes>

    </>
  );
}

export default App;
